import httpService from "Root/api/httpService";
export const apiGetQuizData = (quizName) => {
    const endpoint = `/api/quiz/get_quiz_data/${quizName}/`;
    return httpService.get(endpoint);
};
export const apiUserEmailExists = (email) => {
    const endpoint = "/api/v2/user/exists/";
    return httpService.post(endpoint, { email });
};
export const apiUserIsAuthenticated = () => {
    const endpoint = "/api/v2/user/is-authenticated/";
    return httpService.get(endpoint);
};
export const apiPostQuizAnswer = (answer) => {
    const endpoint = "/api/quiz/submit_answer/";
    return httpService.post(endpoint, answer);
};
export const apiUpdateCart = (cart) => {
    const endpoint = "/api/v2/anonymous-cart/";
    return httpService.post(endpoint, cart);
};
export const apiGetACart = () => {
    const endpoint = "/api/v2/anonymous-cart/";
    return httpService.get(endpoint);
};
export const apiGetEmail = () => {
    const endpoint = "/api/email/";
    return httpService.get(endpoint);
};
export const apiPostBundlesAnswer = (answer) => {
    const endpoint = "/api/quiz/submit-bulk-answers/";
    return httpService.post(endpoint, answer);
};
export const apiQuizSignUp = (body) => {
    const endpoint = "/api/quiz/signup/";
    return httpService.post(endpoint, body);
};
export const apiQuizFinish = (body) => {
    const endpoint = "/api/quiz/finish/";
    return httpService.post(endpoint, body);
};
export const apiGetHelpText = (body) => {
    const endpoint = "/api/quiz/dynamic-help-text/";
    return httpService.post(endpoint, body);
};
export const apiAttribution = (body) => {
    const endpoint = "/api/quiz/save-attribution-source/";
    return httpService.post(endpoint, body);
};
export const apiGetQuizUrl = () => {
    const endpoint = "/api/get-quiz-url/";
    return httpService.get(endpoint);
};
export const apiGetUpsellRecommendations = () => {
    const endpoint = "/api/v2/get-personalized-upsell-recommendations-checkout/";
    return httpService.get(endpoint);
};
export const apiGetBaseProfile = (hideError = false) => {
    const endpoint = "/api/v2/base-profile/";
    return httpService.get(endpoint, hideError);
};
export const apiSendRewardsReferrer = (body) => {
    const endpoint = "/api/rewards/record-event/";
    return httpService.post(endpoint, body);
};
export const apiGetTargetProducts = (product_string) => {
    let endpoint = "/api/target/products/";
    if (product_string) {
        endpoint += "?products=" + product_string;
    }
    return httpService.get(endpoint);
};
export const apiUpdateRetakeQuizAnswer = (data) => {
    const endpoint = "/api/quiz/update-quiz-answers/quiz/";
    return httpService.post(endpoint, data);
};
